module.exports = __webpack_public_path__ + "static/media/ios-basket.d341ba6c.svg";